import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';

interface FAQItemProps {
  question: string;
  answer: string;
}

export default function FAQItem({ question, answer }: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className='w-full  py-3'>
      <div
        className='flex justify-between items-center cursor-pointer'
        onClick={() => setIsOpen(!isOpen)}
      >
        <motion.span
          className='text-base'
          animate={{ color: isOpen ? 'var(--primary-color)' : 'var(--tw-text-main)' }}
          transition={{ duration: 1, ease: 'easeInOut' }}
        >
          {question}
        </motion.span>
        {isOpen ? <Minus className='text-primary' /> : <Plus className='text-primary' />}
      </div>

      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className='overflow-hidden mt-2 text-sm text-muted'
          >
            <span className='text-base text-light/70'>{answer}</span>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
